(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/typeof", "whatwg-fetch"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/typeof"), require("whatwg-fetch"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectSpread, global._typeof, global.whatwgFetch);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectSpread2, _typeof2, _whatwgFetch) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.post = _exports.get = void 0;
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _typeof2 = _interopRequireDefault(_typeof2);
  var dataTypes = ['json', 'html'];

  var buildParams = function buildParams(data) {
    var dataStr = data;

    if (data && typeof data !== 'string') {
      var dataStrArr = [];

      for (var prop in data) {
        // eslint-disable-line
        dataStrArr.unshift("".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent((0, _typeof2.default)(data[prop]) === 'object' ? JSON.stringify(data[prop]) : data[prop])));
      }

      dataStr = dataStrArr.join('&');
    }

    return dataStr;
  };

  var beforeRequest = function beforeRequest(url, data, dataType) {
    if (typeof data === 'string' && dataTypes.indexOf(data) !== -1) {
      dataType = data;
      data = null;
    }

    data = buildParams(data);
    return {
      url: url,
      data: data,
      dataType: dataType
    };
  };

  var afterRequest = function afterRequest(dataType, rawFetch) {
    if (dataType === 'json') {
      rawFetch = rawFetch.then(function (response) {
        return response.json();
      });
    } else if (dataType === 'html') {
      rawFetch = rawFetch.then(function (response) {
        return response.text();
      });
    }

    return rawFetch;
  };

  var post = function post(url, data, dataType, _customHeader) {
    var customHeader = _customHeader || {};

    var _beforeRequest = beforeRequest(url, data, dataType);

    url = _beforeRequest.url;
    data = _beforeRequest.data;
    dataType = _beforeRequest.dataType;
    var rawFetch = fetch(url, {
      method: 'POST',
      headers: (0, _objectSpread2.default)({
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }, customHeader),
      credentials: 'include',
      body: data
    });
    return afterRequest(dataType, rawFetch);
  };

  _exports.post = post;

  var get = function get(url, data, dataType) {
    var _beforeRequest2 = beforeRequest(url, data, dataType);

    url = _beforeRequest2.url;
    data = _beforeRequest2.data;
    dataType = _beforeRequest2.dataType;

    if (data) {
      url += (/\?/.test(url) ? '&' : '?') + data;
    }

    var rawFetch = fetch(url, {
      credentials: 'include'
    });
    return afterRequest(dataType, rawFetch);
  };

  _exports.get = get;
});